import { render, staticRenderFns } from "./UploadProve.vue?vue&type=template&id=9cf04c66&scoped=true&"
import script from "./UploadProve.vue?vue&type=script&lang=js&"
export * from "./UploadProve.vue?vue&type=script&lang=js&"
import style0 from "./UploadProve.vue?vue&type=style&index=0&id=9cf04c66&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cf04c66",
  null
  
)

export default component.exports